export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.03156346,0,0,0.03156311,-0.52315445,-8.3146069)"
  >
    <path
      d="m 358.286,786.286 q 0,7.429 -5.714,13.143 L 324.001,828 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 31.429,561.714 Q 25.715,556 25.715,548.571 q 0,-7.429 5.714,-13.143 L 297.715,269.142 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 l 28.571,28.571 q 5.714,5.714 5.714,13.143 0,7.429 -5.714,13.143 L 128.001,548.57 352.572,773.141 q 5.714,5.714 5.714,13.143 z m 219.428,0 q 0,7.429 -5.714,13.143 L 543.429,828 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 250.857,561.714 q -5.714,-5.714 -5.714,-13.143 0,-7.429 5.714,-13.143 L 517.143,269.142 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 L 572,297.713 q 5.714,5.714 5.714,13.143 0,7.429 -5.714,13.143 L 347.429,548.57 572,773.141 q 5.714,5.714 5.714,13.143 z"
    />
  </g>
</svg>`;
